function stripVietnameseDiacritics(value: string): string {
  return value
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function normalizeApartmentCodeForSearch(value: string): string {
  return stripVietnameseDiacritics(value)
    .trim()
    .toUpperCase()
    .replace(/[-.\s]/g, '');
}

function fieldMatchesCompact(field: string | null | undefined, compactQuery: string): boolean {
  if (!field || !compactQuery) {
    return false;
  }
  return normalizeApartmentCodeForSearch(field).includes(compactQuery);
}

export function apartmentMatchesSearchTerm(
  fields: {
    code: string;
    name?: string | null;
    ownerName?: string | null;
    usageTypeName?: string | null;
    usageTypeCode?: string | null;
  },
  searchTerm: string,
): boolean {
  const q = searchTerm.trim();
  if (!q) {
    return true;
  }
  const lower = q.toLowerCase();
  const compactQuery = normalizeApartmentCodeForSearch(q);

  const textFields = [
    fields.code,
    fields.name,
    fields.ownerName,
    fields.usageTypeName,
    fields.usageTypeCode,
  ];
  for (const field of textFields) {
    if (field && field.toLowerCase().includes(lower)) {
      return true;
    }
    if (fieldMatchesCompact(field, compactQuery)) {
      return true;
    }
  }
  return false;
}
